import {EMPTY_FILTER, ENDPOINTS} from "../constants/index.js";

export function insertValue(arr, index, value) {
  const newArr = [...arr];

  if (index >= arr.length) {
    newArr.push(value);
  } else {
    newArr.splice(index, 0, value);
  }
  return newArr;
}

export function extractSlugAndTypeFromUrl(url, language = "fr") {
  const segmentRegex = /([^/]+)\/\?slug=([\w-]+)$/;
  const match = url.match(segmentRegex);
  if (match) {
    return {
      type: match[1] === "posts" ? ENDPOINTS.posts[language] : "destination",
      slug: match[2],
    };
  }
}

export const translateMetaUrl = (url, language) => {
  if (url) {
    const articleRegex = /(article|artokel|articulo)\//;
    const match = url.match(articleRegex);
    if (match) {
      return url.replace(articleRegex, `${ENDPOINTS.posts[language]}/`);
    }
    return url;
  }
  return null;
};

export function transformSlug(slug) {
  const parts = slug.split("/");
  const lastPart = parts.pop();
  return lastPart.includes("?slug=")
    ? `${parts.join("/")}/${lastPart.split("=")[1]}`
    : `${parts.join("/")}/${lastPart}`;
}

export function getLastSlug(path) {
  const trimmedPath = path?.replace(/\/+$/, "");
  const slugs = trimmedPath?.split("/");
  return slugs?.[slugs?.length - 1];
}

export function compareSlugs(firstSlug, secondSlug) {
  const correctSlug = firstSlug.replace(/\//g, "");
  const slug = secondSlug.replace(/\//g, "");

  return correctSlug === slug;
}

export function isJsonContentType(contentType) {
  return /json/.test(contentType);
}

export function removeDoubleSlash(url1, url2) {
  if (url1.endsWith("/") && url2.startsWith("/")) {
    return url1 + url2.slice(1);
  }
  return url1 + url2;
}

export const parseParam = (param) => (param === EMPTY_FILTER ? EMPTY_FILTER : +param);
